import React, {useEffect, useRef, useState} from 'react';
import { useHistory } from "react-router-dom";
import styles from "../css/Commentator.module.css";
import {
    Pagination,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import Swal from "sweetalert2";
import Box from "components/inputs/Box";
import Button from "components/inputs/Button";

import { useDispatch, useSelector } from "react-redux";
import { commonActions } from "reducers/common";
import { commentatorActions } from "reducers/commentator";

import CommentatorModal from "./CommentatorModal";
import { resetArray } from "service/util/resetArray";
import CommentatorService from "service/apiConfig/CommentatorService";
import CommentatorSearch from "./CommentatorSearch";

const Commentator = () => {
    const commentatorIdRef = useRef();
    const dispatch = useDispatch();
    const history = useHistory();
    const commentatorList = useSelector(state => state.commentatorData.commentatorList);
    const limit = 8;
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(() => JSON.parse(window.localStorage.getItem('page')) || 1);
    const offset = (page - 1) * limit;

    useEffect(() => {
        dispatch(commonActions.trueIsLoading());
        CommentatorService.getAll()
            .then(response => {
                const arr = resetArray(response)
                dispatch(commentatorActions.setCommentatorList(arr));
                dispatch(commonActions.falseIsLoading());
            })
            .catch(err => console.log(err))
    }, [page, pageCount, dispatch])

    useEffect(() => {
        window.localStorage.setItem('commentatorPage', JSON.stringify(pageCount));
        setPage(pageCount);
    }, [page, pageCount, dispatch])


    const handleOpenDetail = (id, item) => {
        dispatch(commentatorActions.setOpenDetail(true));
        dispatch(commentatorActions.setCommentatorDetail(item));
    }

    const handlePageChange = (e, value) => {
        setPage(value)
        setPageCount(value)
    }

    const onCreateComm = () => {
        history.push("/setting/create/commentator");
    }

    const onDeleted = (id) => {
        Swal.fire({
            title: '정말 삭제하시겠습니까 ?',
            icon: 'warning',
            confirmButtonText: '네',
            cancelButtonText: '아니오',
            showCancelButton: true,
            confirmButtonColor: '#D55240',
        }).then(result => {
            if (result.isConfirmed) {
                CommentatorService.deleted(id)
                    .then(response => {
                        const list = commentatorList.filter(item => item.id !== id);
                        dispatch(commentatorActions.setCommentatorList(list));
                        return true;
                    })
                    .catch(err => console.log(err));
            }
        });
    }
    return (
        <>
        <section className={`sectionWrap commentatorWrap ${styles.commentatorWrap}`}>
            <header>
                <h2>해설자 관리</h2>
                <Button onClick={onCreateComm} style={{ background: "#A2B521" }}>
                    등록
                </Button>
            </header>
           <CommentatorSearch setPage={setPage} />
            <Box>
                <TableContainer className={styles.commList} component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align={"center"} style={{ maxWidth: "40px" }}>No</TableCell>
                                <TableCell>이미지</TableCell>
                                <TableCell>해설자이름</TableCell>
                                <TableCell>해설자 영문이름</TableCell>
                                <TableCell align={"center"} style={{ maxWidth: '100px' }}>활성화 상태</TableCell>
                                <TableCell> </TableCell>
                            </TableRow>
                        </TableHead>
                        {commentatorList.length >= 1 &&
                            <TableBody>
                                {commentatorList.slice(offset, offset + limit).map((value, index) => (
                                    <TableRow
                                        key={value.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell align={"center"} style={{ maxWidth: "40px" }}>
                                            {value.index}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            <input ref={commentatorIdRef} type={"hidden"} value={value.id} />
                                            <img src={value.imageUrl !== null && value.imageUrl} alt={"profile"} />
                                        </TableCell>
                                        <TableCell>
                                            {value.name}
                                        </TableCell>
                                        <TableCell>
                                            <span>{value.nameEng}</span>
                                        </TableCell>
                                        <TableCell align={"center"} sx={{ maxWidth: '100px' }}>
                                            <span className={`invalidCircle ${value.invalid === false ? 'invalid' : ''}`}/>
                                            {value.invalid === false ? '활성화' : '비활성화'}
                                            {/*<Switch*/}
                                            {/*    className={styles.invalid}*/}
                                            {/*    name={"invalid"}*/}
                                            {/*    sx={{ margin: "0" }}*/}
                                            {/*    checked={value.invalid === false || value.invalid === "false" || false}*/}
                                            {/*    disabled*/}
                                            {/*/>*/}
                                        </TableCell>
                                        <TableCell align="right">
                                            <Button onClick={() => handleOpenDetail(value.id, value)} style={{ background: "#dfa78f" }}>수정</Button>
                                            <Button onClick={() => onDeleted(value.id)} style={{ background: "#D55240", marginLeft: "0.2rem" }}>삭제</Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        }
                    </Table>
                </TableContainer>
                {commentatorList.length < 1 && <p style={{ padding: "3rem" }} className={"noData"}>데이터가 없습니다.</p>}
                {commentatorList.length >= 1 && <Pagination className={"pagination"} page={page} onChange={handlePageChange} count={Math.ceil(commentatorList.length / limit)} />}
            </Box>
            <CommentatorModal />
        </section>
        </>
    );
};

export default Commentator;